import React from 'react'

const Stayintouch = () => {
  return (
    <div className=' grid justify-center items-center mt-20 mx-5'>
      <h3 className='text-[36px] font-bold'>Stay in touch with CPAP Market</h3>
      <h3 className='text-center my-5'>Be the first to know about our News and Great Deals</h3>
      <div className='justify-self-center my-8 relative'>
            <input type="email" placeholder='Enter email'className='border-2 border-[grey] px-4 lg:w-[320px] md:w-[320px] w-[200px] relative h-[45px] rounded-3xl' />
            <button className="text-white lg:w-[150px] md:w-[150px] w-[100px] h-[45px] bg-[#F0592A]  rounded-3xl  absolute lg:left-[170px] md:left-[170px] left-[100px]">Sign up</button>
       </div>
    </div>
  )
}

export default Stayintouch
